
// tipoPersonaService.js
import api from './api';

export const tipoPersonaService = {
    obtenerTodos: () => api.get('/get/obtener_tipospersona.php')
        .then(response => ({
            data: Array.isArray(response.data) ? response.data : response.data?.data || []
        }))
};
